<!-- HEADER DA TELA (nome do sistema + busca) -->
<div
  class="shrink-0 flex flex-col sm:flex-row gap-2 sm:gap-3 items-start sm:items-center justify-between pt-2 sm:pt-3 mb-2 sm:mb-3"
>
  <h3
    class="nome-grupo-header text-[#0C0C1A] dark:text-[#F4F7FB] truncate max-w-full w-full sm:w-auto sm:pr-4"
  >
    {{ modulos.length ? modulos[0].nome : "Meus módulos" }}
  </h3>

  <div class="flex items-center gap-3 w-full sm:w-auto">
    <!-- Busca -->
    <div class="w-full sm:w-[291px] h-[45px]">
      <div class="relative w-full h-full">
        <input
          type="text"
          [(ngModel)]="termoBusca"
          (ngModelChange)="buscar()"
          inputmode="search"
          placeholder="Procurar produtos"
          class="w-full h-full rounded-[12px] pl-4 pr-12 font-canvi font-normal text-[14px] leading-[16.8px] tracking-[0] text-[#0C0C1A] dark:text-[#DDDBDF] bg-white dark:bg-[#22223A] border border-[#DDDBDF] dark:border-[#303049] placeholder:text-[#A1A1B5] dark:placeholder:text-[#A1A1B5] focus:outline-none focus:ring-0 focus:border-[#DDDBDF] dark:focus:border-[#303049]"
          autocomplete="off"
        />

        <button
          type="button"
          class="cursor-pointer flex items-center justify-center w-6 h-6 absolute right-4 top-1/2 -translate-y-1/2 bg-transparent border-0"
          (click)="buscar()"
          aria-label="Buscar"
        >
          <svg
            class="w-5 h-5 text-[#0C0C1A] dark:text-[#DDDBDF]"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 20"
            aria-hidden="true"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- LISTA DE MÓDULOS (cards) -->
<div class="flex-1 min-h-0 overflow-auto">
  @if (modulosFiltrados.length > 0) {
    <div *ngFor="let grupo of modulosFiltrados" class="mb-6 sm:mb-8">
      <div
        class="grid gap-3 sm:gap-4 justify-start [grid-template-columns:repeat(auto-fill,minmax(220px,280px))] md:[grid-template-columns:repeat(auto-fill,minmax(240px,300px))] 2xl:[grid-template-columns:repeat(auto-fill,minmax(260px,320px))]"
      >
        <div
          *ngFor="let modulo of grupo.modulos"
          (click)="acessarModulo(modulo)"
          class="group cursor-pointer relative h-[215px] rounded-[16px] border border-[#EDEAF0] dark:border-[#303049] bg-white dark:bg-[#22223A] overflow-hidden flex flex-col motion-safe:transition hover:shadow-sm motion-safe:hover:scale-[1.01]"
        >
          <!-- FIXADO -->
          @if (estaFixado(modulo)) {
            <span
              class="absolute left-3 top-3 z-30 inline-flex items-center text-[11px] font-medium px-2 py-0.5 rounded-full bg-white/85 dark:bg-[#151528]/70 text-[#0C0C1A] dark:text-white backdrop-blur-sm ring-1 ring-black/5 dark:ring-white/15"
            >
              Fixado
            </span>
          }

          <!-- BOTÃO PIN -->
          <div
            class="absolute right-2 top-2 z-30 flex items-center opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition-opacity duration-150"
            [class.opacity-100]="estaFixado(modulo)"
            [class.pointer-events-auto]="estaFixado(modulo)"
          >
            <button
              type="button"
              class="p-2 rounded-lg border border-[#EDEAF0] dark:border-[#303049] bg-white/70 dark:bg-[#151528]/70 hover:bg-white dark:hover:bg-[#151528]"
              (click)="$event.stopPropagation(); alternarFixacao(modulo)"
              aria-label="Alternar fixação"
            >
              <img
                src="icons/icons-navbar-submenu/fixador.svg"
                class="w-4 h-4 filter brightness-0 dark:invert"
                [ngClass]="{
                  'opacity-100': estaFixado(modulo),
                  'opacity-60': !estaFixado(modulo),
                }"
              />
            </button>
          </div>

          <!-- TOPO COM BACKGROUND -->
          <div class="relative h-[120px] w-full">
            <img
              class="absolute inset-0 w-full h-full object-cover"
              [src]="
                getCardVariant(modulo) === 'red'
                  ? isDarkMode
                    ? 'background/cardsModulos/redBackgroudCardsDark.svg'
                    : 'background/cardsModulos/redBackgroundCardsLight.svg'
                  : isDarkMode
                    ? 'background/cardsModulos/blueBackgroundCards.svg'
                    : 'background/cardsModulos/blueBackgroundCrdsLight.svg'
              "
              alt=""
              aria-hidden="true"
            />
          </div>

          <!-- BASE DO CARD -->
          <div
            class="flex-1 px-4 pt-3 pb-4 flex flex-col justify-between bg-white dark:bg-[#22223A] border-t border-[#EDEAF0] dark:border-[#303049]"
          >
            <div class="flex items-start justify-between gap-3">
              <span
                class="font-canvi font-semibold text-[16px] leading-[120%] tracking-[0] line-clamp-2 text-[#0C0C1A] dark:text-[#FCFCFD]"
              >
                {{ modulo.nome }}
              </span>

              <img
                src="icons/icons-navbar-submenu/iconSetaReta.svg"
                alt="Ir"
                class="w-5 h-5 opacity-90 filter brightness-0 dark:invert"
              />
            </div>

            <p
              class="mt-2 font-canvi font-normal text-[12px] leading-[120%] tracking-[0] text-[#74757F] dark:text-[#DDDBDF]"
            >
              {{ getCardTexto(modulo) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <ng-container [ngTemplateOutlet]="semModulos"></ng-container>
  }

  <ng-template #semModulos>
    <p
      class="text-center text-[#74757F] dark:text-gray-300 mt-5 text-sm sm:text-base"
    >
      Módulo não encontrado.
    </p>
  </ng-template>
</div>
